import { Button, Dropdown, Menu, Select, Space } from "antd";
import { Option } from "antd/lib/mentions";
import React, { Component } from "react";
import "./app_filters.css";
import { ReactComponent as SortIcon } from "../../../Sort.svg";

class AppDropdownSort extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (value) => {
        //console.log(value);
        this.props.onSelectedOptions(value);
    }

    renderCaption = () => {
        return this.props.options.map((item, idx) => {
            return (
                <Option value={item.values} className="dropdown-filter__item">
                    {item.captions}
                </Option>
            );
        });
    }

    render() {
        return (
            <>
                <div>
                    <div className="dropdown-filter3 d-flex justify-content-center align-items-center">
                        <Select
                            style={{
                                width: '100%',
                            }}
                            size={"large"}
                            onChange={this.handleChange}
                            bordered={false}
                            suffixIcon={<SortIcon />}
                            defaultValue={this.props.default}
                            value={this.props.filterCriteria}
                        >
                            {this.renderCaption()}
                        </Select>
                    </div>
                </div>
            </>
        );
    }
}

export default AppDropdownSort;
